import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../context/StoreContext';

export default function TrialBanner() {
  const { selectedStore } = useStore();
  const navigate = useNavigate();

  const trialInfo = useMemo(() => {
    const trialEndsAt = selectedStore?.trial_ends_at;
    if (!trialEndsAt) return null;
    const end = new Date(trialEndsAt);
    const now = new Date();
    const daysLeft = Math.ceil((end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
    return { daysLeft, expired: daysLeft <= 0 };
  }, [selectedStore]);

  useEffect(() => {
    if (!selectedStore?.id || !trialInfo) return;
    if (trialInfo.expired || trialInfo.daysLeft <= 3) {
      const promptKey = `trial-upgrade-prompt:${selectedStore.id}:${trialInfo.daysLeft}`;
      if (sessionStorage.getItem(promptKey)) return;
      sessionStorage.setItem(promptKey, '1');
      window.dispatchEvent(new CustomEvent('aiviora:upgrade-trigger', {
        detail: {
          code: trialInfo.expired ? 'trial_expired' : 'trial_expiring',
          title: trialInfo.expired ? 'Trial expired' : 'Trial ending soon',
          message: trialInfo.expired
            ? 'Trial expired - upgrade to continue'
            : `Trial ends in ${trialInfo.daysLeft} day${trialInfo.daysLeft === 1 ? '' : 's'}`,
        },
      }));
    }
  }, [selectedStore, trialInfo]);

  if (!trialInfo) return null;

  return (
    <div className="trial-banner">
      <span>
        {trialInfo.expired
          ? 'Trial expired - upgrade to continue'
          : `Trial ends in ${trialInfo.daysLeft} day${trialInfo.daysLeft === 1 ? '' : 's'}`}
      </span>
      <button className="btn btn-outline btn-sm" onClick={() => navigate('/pricing')}>
        Upgrade
      </button>
    </div>
  );
}
